import type { AxiosInstance } from "axios";
import { DLS_URL } from "~/env";
import { sendRequest } from "~/utils/axios-utils";

export default ($axios: AxiosInstance) => {
  $axios.defaults.baseURL = DLS_URL;

  return {
    /**
     * 获取专业领域
     */
    getCardDomains: () =>
      sendRequest($axios, {
        method: "GET",
        url: "/dls/api/app/v1/card/domains",
      }),
    /**
     * 获取地区数据
     */
    getCityList: () =>
      sendRequest($axios, {
        method: "GET",
        url: "/dls/api/v3/user/cityList",
      }),
    /**
     * 文件上传（无需登录）
     */
    uploadFileGetUrl: (form: FormData) =>
      sendRequest($axios, {
        method: "POST",
        url: "/dls/api/v1/file/uploadFileGetUrlOpen",
        data: form,
      }),
    /**
     * 律师入驻
     */
    lawyerRegister: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: "/dls/api/applet/v3/lawyer/lawyerRegister",
        data: params,
      }),
    /**
     * 律师入驻的广播信息获取
     */
    getInformationBroadcast: () =>
      sendRequest($axios, {
        method: "GET",
        url: "/dls/api/applet/v3/lawyer/queryLawyerDynamic",
      }),
    /**
     * 律助积分获取方式
     */
    getPointsWays: () =>
      sendRequest($axios, {
        method: "GET",
        url: "/dls/api/app/v1/points/queryDlsPointsRuleList",
      }),

    //青年律师入驻
    //获取邀请连接
    getQLShareUrl: (params: any) =>
      sendRequest($axios, {
        method: "GET",
        url: "/dls/api/v1/points/getShareUrl",
        params,
      }),
    //获取头部信息
    getLastLoginCorpId: () =>
      sendRequest($axios, {
        method: "GET",
        url: "/dls/api/v3/user/getLastLoginCorpId",
      }),
    //律师入驻邀请名单列表
    queryInviteRecordList: (params: any) =>
      sendRequest($axios, {
        method: "GET",
        url: "/dls/api/applet/v3/lawyer/queryInviteRecordList",
        params,
      }),
  };
};
